import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isCreating: false,
  isCreated: false,
  isFailed: false,
  isDeleted: false,
  procedures: [],
  procedure_on_request: [],
  procedure: {},
  isLoading: false,
  isGotProcedure: false,
  previousRoute: [],
  procPage: 1,
};
const ProcedureReducer = createSlice({
  name: 'Procedure',
  initialState,
  reducers: {
    ResetProcedure: state => {
      state.isCreated = false;
      state.isCreating = false;
      state.isFailed = false;
      state.isDeleted = false;
      state.isLoading = false;
      state.isGotProcedure = false;
    },
    LoadProceduresRequest: (state, action) => {
      state.isLoading = true;
    },
    LoadProceduresRequestEnd: (state, action) => {
      state.isLoading = false;
    },
    LoadProcedures: (state, action) => {
      state.procedures = [...action.payload];
      state.isGotProcedure = true;
    },
    LoadProcedureOnRequest: (state, action) => {
      state.procedure_on_request = action.payload;
      state.isGotProcedure = true;
    },
    RequestOfCreatingProcedure: state => {
      state.isCreating = true;
    },
    CreateProcedureSuccess: (state, action) => {
      state.isCreating = false;
      state.isCreated = true;
      state.procedures.push(action.payload);
    },
    CreateProcedureFailed: (state, action) => {
      state.isCreating = false;
      state.isFailed = true;
    },
    ProcedureDeleteSuccess: (state, action) => {
      state.procedures = state.procedures.filter(p => p._id !== action.payload);
      state.isDeleted = true;
    },
    ProcedureUpdateSuccess: (state, action) => {
      const indexOfUpdate = state.procedures.findIndex(
        pro => pro._id === action.payload._id
      );
      state.procedures[indexOfUpdate] = { ...action.payload };
    },
    GetOneProcedure: (state, action) => {
      state.procedure = state.procedures.find(
        _procedure => _procedure._id === action.payload
      );
      state.isGotProcedure = true;
    },
    SetPreviousRoute: (state, action) => {
      state.previousRoute = action.payload;
    },
    SetProcPage: (state, action) => {
      state.procPage = action.payload;
    },
    // GetProceduresByFolderId:(state,action)=>{
    //   state.procedures=state.proce
    // }
  },
});
export default ProcedureReducer.reducer;
export const {
  RequestOfCreatingProcedure,
  CreateProcedureSuccess,
  CreateProcedureFailed,
  ResetProcedure,
  LoadProcedures,
  ProcedureDeleteSuccess,
  ProcedureUpdateSuccess,
  GetOneProcedure,
  LoadProceduresRequest,
  LoadProcedureOnRequest,
  LoadProceduresRequestEnd,
  SetPreviousRoute,
  SetProcPage,
} = ProcedureReducer.actions;
